import { crewDb } from "@/services/common/db/dexie";

const addCrewReportPhotos = async (report: {
  taskId: number;
  photos: { photoId: number; lastModified: number }[];
}) => {
  try {
    for (const photo of report.photos) {
      if (photo.lastModified) {
        await crewDb.reportPhotos.add({
          ...photo,
          taskId: Number(report.taskId)
        });
      }
    }
  } catch (error) {
    console.error("addCrewReportPhotos error", error);
  }
};

const getCrewReportPhotos = async (taskId: number) => {
  try {
    return await crewDb.reportPhotos
      .where("taskId")
      .equals(Number(taskId))
      .toArray();
  } catch (error) {
    console.error("getCrewReportPhotos error", error);
  }
};

const deleteCrewReportPhotos = async (taskId: number) => {
  try {
    return await crewDb.reportPhotos
      .where("taskId")
      .equals(Number(taskId))
      .delete();
  } catch (error) {
    console.error("deleteCrewReportPhotos error", error);
  }
};

export { addCrewReportPhotos, getCrewReportPhotos, deleteCrewReportPhotos };
